// extracted by mini-css-extract-plugin
export default {"lnr":"SettingsForm_lnr__I5gQ7","button__toolbar":"SettingsForm_button__toolbar__Zrwd6","loader":"SettingsForm_loader__h-hAf"};